import { useContext } from 'react';
import { ToastContext } from '../../../contexts/toast';

export const useToast = () => {
  const { openToast } = useContext(ToastContext);

  return openToast;
};
